<template>
  <section
    v-if="variant === variants.v1"
    class="n-section-primary tw-overflow-hidden"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};`"
  >
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="right_bottom"
      :company-key="company.company_key"
    />
    <div class="tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-10 lg:tw-gap-14">
      <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-center tw-gap-3 tw-text-start">
        <h6 class="tw-uppercase">{{ vars.altTitleText }}</h6>
        <h2 class="tw-uppercase">{{ vars.titleText }}</h2>
      </div>

      <div class="tw-w-full">
        <Swiper
          :modules="[SwiperPagination]"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          :loop="true"
          :loop-add-blank-slides="true"
          :pagination="false"
          :slides-per-view="1"
          :space-between="24"
          effect="fade"
          :clickable="true"
          :breakpoints="{
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }"
          class="tw-w-full lg:tw-w-[130%]"
        >
          <SwiperSlide v-for="(card, index) in cards" :key="index">
            <div
              :key="index"
              class="tw-flex tw-h-full tw-min-h-[390px] tw-flex-col tw-gap-3 tw-text-start lg:tw-min-h-[400px]"
              :style="`border-radius: var(--rounded); border-color: var(--c-border);`"
            >
              <div class="tw-w-full">
                <library-image
                  :src="card.photo"
                  :h-ratio="31"
                  :w-ratio="47"
                  style="border-radius: var(--rounded)"
                ></library-image>
              </div>
              <h3 class="tw-mt-2 tw-uppercase">{{ card.title }}</h3>
              <p>{{ card.description }}</p>
            </div>
          </SwiperSlide>
        </Swiper>
        <div class="tw-mt-10">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v5"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'ProcessSlider',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return {
      reviewsV2: null,
      swiper: null,
      canPaginateBack: false,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      try {
        if (!this.swiper) return;

        const isAtStart = this.swiper.isBeginning;
        const isAtEnd = this.swiper.isEnd;

        this.canPaginateBack = !isAtStart;
        this.canPaginateNext = !isAtEnd;
      } catch (error) {
        console.error('Error in onSlideChange:', error);
      }
    },
  },
});
</script>
